import { inject, Injectable, signal } from '@angular/core';

import { TellentAssistantService } from '@core/tellent-assistant-logic';

// Root-scoped so the size survives the modal being recreated per open (e.g.
// recruitee-mobile's ModalController.create()). Expanded by default: nearly every
// way in lands straight in a conversation.
@Injectable({ providedIn: 'root' })
export class TellentAssistantMobileExpandedStateService {
  private readonly assistant = inject(TellentAssistantService);

  public readonly expanded = signal(true);

  public markExpanded(): void {
    this.expanded.set(true);
  }

  // Trigger only: the one entry point that may land on the empty state. Messages
  // in the thread mean the tap resumes a conversation, so it opens expanded.
  public applyTriggerOpenSize(): void {
    this.expanded.set(this.assistant.messages().length > 0);
  }
}
